export let isPasswordValid = (password: string): boolean => {

    var expression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{6,12}$/;
    var regex = new RegExp(expression);
    if (password.match(regex)) {
      return true;
    } else {
      return false;
    }
  };